/**
 * Fields a `link` item may carry that point at its target.
 *
 * `url` can be missing on rows written by older sync code: X bookmarks were
 * saved with only `tweet_url`. Never call string/URL methods on `content.url`
 * directly; go through `getLinkUrl` so the value is always a string.
 */
export interface LinkTarget {
  url?: string | null;
  tweet_url?: string | null;
}

/** Resolve the URL a link item points at. Returns '' when there is none. */
export function getLinkUrl(content: LinkTarget | null | undefined): string {
  if (!content) return '';
  if (typeof content.url === 'string' && content.url) return content.url;
  if (typeof content.tweet_url === 'string' && content.tweet_url) return content.tweet_url;
  return '';
}
